/**
 * Created by Анжелика on 17.11.2017.
 */
export const STR_RETURN = 'Выход';
export const STR_MENU = 'Меню';
export const STR_EPG = 'EPG';
export const STR_PLAYER_BACK = 'Назад к выбору канала';
export const STR_PLAYER_CONTINUE = 'Закрыть';

export const STR_LOGIN_LOGIN = 'Логин';
export const STR_LOGIN_PASSWORD = 'Пароль';
export const STR_LOGIN_ENTRY = 'Вход';
export const STR_LOGIN_REGISTRATION = 'Регистрация';
export const STR_LOGIN_PLACEHOLDER_LOGIN = 'Введите логин';
export const STR_LOGIN_PLACEHOLDER_PASSWORD = 'Введите пароль';

export const STR_REG_LABEL_FULL_NAME = 'ФИО';
export const STR_REG_LABEL_EMAIL = 'E-mail';
export const STR_REG_LABEL_PASSWORD1 = 'Придумайте пароль';
export const STR_REG_LABEL_PASSWORD2 = 'Подтвердите пароль';
export const STR_REG_PLACEHOLDER_FULL_NAME = 'Введите ФИО';
export const STR_REG_PLACEHOLDER_EMAIL = 'Введите email адрес';
export const STR_REG_PLACEHOLDER_PASSWORD1 = 'Введите пароль';
export const STR_REG_PLACEHOLDER_PASSWORD2 = 'Введите пароль заново';
export const STR_REG_REGISTER = 'Зарегистрироваться';
export const STR_REG_HAS_CREDS = 'Вход в существующий аккаунт';

export const STR_MENU_GENRES = 'Жанры';
export const STR_MENU_SETTINGS = 'Настройки';
export const STR_MENU_USER = 'Пользователь';
export const STR_MENU_EXIT = 'Выход';
export const STR_CHANNEL_LIST_EMPTY = 'Каналы не найдены';

export const STR_EPG_CURRENT_NOW_LABEL = 'Сейчас';
export const STR_EPG_LOADING = 'Загрузка...';
export const STR_EPG_MORE = 'Загрузить';

export const STR_USERDATA_SECTION_INFO = 'Информация';
export const STR_USERDATA_SECTION_TARIFF = 'Тариф';
export const STR_USERDATA_SECTION_CONTACTS = 'Контакты';
export const STR_USERDATA_TARIFF_PLAN = 'Тарифный план';
export const STR_USERDATA_PHONE = 'Телефон';

export const PAGE_NOT_FOUND_TITLE = '404 Страница не существует';
export const PAGE_NOT_FOUND_MSG = 'К сожалению запрашиваемая вами страница не найдена';
export const CHANNEL_NOT_FOUND = 'Канал не найден';
export const VIDEO_ERROR_POPUP_TITLE_HLS = 'Ошибка воспроизведения';
export const VIDEO_ERROR_POPUP_TITLE_FORMAT = 'Ошибка формата видео';
export const EPG_MISSING = 'Программа телепередач отсутствует';



// WEBPACK FOOTER //
// ./src/constants/strings.js